import { MiddlewareAPI } from "redux";
import { io, Socket } from 'socket.io-client';

export interface WebSocketAction {
    readonly type: string;
    readonly payload?: string;
};

export interface IWsActions
{
    wsInit: string;
    onOpen: () => WebSocketAction,
    onClose: (payload: string) => WebSocketAction,
    onError: (payload: string) => WebSocketAction,
    onMessage: (payload: string, dispatch: Function) => WebSocketAction
}

interface ErrorEvent extends Event {
    message?: string;
}

export const socketMiddleware = (wsUrl: string, wsActions: IWsActions) => {
    return (store: MiddlewareAPI) => {
        const { dispatch } = store;

        const socket = io(wsUrl, {
            transports: ['websocket'],
            reconnection: true,
            secure: true
        });

        socket.on('connect', () => {
            console.log('Connected to the WebSocket server');
            dispatch(wsActions.onOpen());
        });

        socket.on('message', (data: any) => {
            console.log('Received message from server:', data);
            dispatch(wsActions.onMessage(data, dispatch));
        });

        socket.on('broadcast', (data) => {
            dispatch(wsActions.onMessage(data, dispatch));
        });
      
        socket.on('connect_error', (error: Error) => {
            console.error('Connection error:', error);
            dispatch(wsActions.onError(error.message));
        });
      
        socket.on('disconnect', (reason: string) => {
            console.log('Disconnected from the WebSocket server');
            dispatch(wsActions.onClose(reason));
        });

        return (next: Function) => (action: WebSocketAction) => {
            const { type, payload } = action;
            
            if (type === wsActions.wsInit) {
                // Инициализация соединения, если нужно
            }
            
            next(action);
        };
    };
};